import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Stripe Connect return placeholder. The actual return is handled by the Netlify
 * function stripe-connect-return, which redirects to /dashboard?stripe=success|error.
 * This page is for direct visits (e.g. bookmark) and redirects to dashboard.
 */
export default function StripeReturn() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const stripe = searchParams.get('stripe');
    const message = searchParams.get('message');
    const params = new URLSearchParams();
    if (stripe) params.set('stripe', stripe);
    if (message) params.set('message', message);
    const qs = params.toString();
    navigate(`/dashboard${qs ? `?${qs}` : ''}`, { replace: true });
  }, [navigate, searchParams]);

  return (
    <div className="min-h-[40vh] flex flex-col items-center justify-center p-6">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-blue-600 mb-4" />
      <p className="text-slate-600">Completing connection…</p>
    </div>
  );
}
